<template>
  <DefaultLayout>
    <TriggerFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Triggers') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ triggers.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <TriggerCreateAction @created="reload" v-if="can('TRIGGER_MANAGE')"
          btnClass="btn btn-sm btn-outline-dark ms-1" />       
      </template>
    </TriggerFilter>

    <TriggerList :pagination="pagination" :triggers="triggers" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import TriggerCreateAction from "@/components/trigger/TriggerCreateAction.vue";
import TriggerFilter from "@/components/trigger/TriggerFilter.vue";
import TriggerList from "@/components/trigger/TriggerList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    TriggerCreateAction,
    TriggerFilter,
    TriggerList,
  },
  data() {
    return {
      listPropertyName: 'triggers',
      apiResource: `triggers`,
      triggers: [],
    }
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'trigger';
    },
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Triggers'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
};
</script>
